import React from 'react'
import styled from 'styled-components'
import ModalContainer from './ModalContainer'
import { Flex } from './Layout'
import Icon from './Icon'
import { RemoveScroll } from 'react-remove-scroll'

const FullScreenWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  z-index: 1300002;
  overflow-y: auto;

  @media (min-width: 1600px) {
    display: none;
  }
`

const ModalWrapper = styled.div`
  display: none;

  @media (min-width: 1600px) {
    display: block;
  }
`

const ResponsiveModal = ({ children, isOpen, setIsOpen, modalProps = {} }) => {
  if (!isOpen) return null

  return (
    <>
      <RemoveScroll enabled={isOpen}>
        <FullScreenWrapper>
          <Flex
            alignItems="center"
            justifyContent="center"
            position="absolute"
            width="auto"
            top="24px"
            right="24px"
            zIndex="1"
            cursor="pointer"
            onClick={() => {
              setIsOpen(false)
            }}
          >
            <Icon width="14px" height="14px" icon="close-cross-grey" />
          </Flex>
          {children}
        </FullScreenWrapper>

        <ModalWrapper>
          <ModalContainer zIndexOveride={1300002} interiorClose p="0px" width="1600px" isOpen={true} setIsOpen={setIsOpen}>
            {children}
          </ModalContainer>
        </ModalWrapper>
      </RemoveScroll>
    </>
  )
}

export default ResponsiveModal
